import request from "../base-request";

export interface IStrategyCategory {
	_id: string;
	name: string;
	company?: object;
	deleted?: boolean;
	deleted_date?: string;
}

export interface IStrategyCategoryData {
	categories: IStrategyCategory[];
	errors: string[];
	warnings: string[];
}

export const getStrategyCategories = async () => {
	const [categoriesData] = await request<IStrategyCategoryData>(`/api/v1.0/companies/strategy-categories/`);

	return categoriesData;
};
